import {
  BackComponent,
  Loader,
  PageMainContent,
  SignPoaView,
} from '@/components'
import { isGenericCompanyDetails } from '@/modules/company/utils/isGenericCompanyDetails'
import { useSnackbar } from '@/providers'
import { paths } from '@/routes/paths'
import { Redirect } from '@/routes/Redirect'
import { useCompany, useUserProfile } from '@/services'
import { useGoToPath, useHistoryState } from '@/utils'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export const PageForm = () => {
  const { t } = useTranslation()
  const { companyId = '' } = useParams()
  const { from } = useHistoryState()

  const goAfterSubmit = useGoToPath(from || paths.dashboard)

  const snackbar = useSnackbar()

  const sendPOA = () => {
    snackbar.success(t('snackbars.success.onPoaSigned'))
    goAfterSubmit()
  }

  return (
    <>
      <BackComponent />
      <SignPoaView
        cancelText={t('common.cancel')}
        companyId={companyId}
        onSuccess={sendPOA}
      />
    </>
  )
}

export const PoaSignPage = () => {
  const { t } = useTranslation()
  const { companyId = '' } = useParams()
  const snackbar = useSnackbar()

  const {
    data: company,
    isLoading: isCompanyLoading,
    isFetching: isCompanyFetching,
  } = useCompany(companyId)
  const {
    data: userProfile,
    isLoading: isProfileLoading,
    isFetching: isProfileFetching,
  } = useUserProfile()
  if (
    isCompanyLoading ||
    isCompanyFetching ||
    isProfileLoading ||
    isProfileFetching
  )
    return <Loader />

  const isGenericCompany = isGenericCompanyDetails(
    company?.name || '',
    company?.address,
  )

  if (company?.poaSigned) return <Redirect to={paths.dashboard} />

  if (isGenericCompany) {
    snackbar.warning(t('profile.poa.fillLocationDetailsMessage'))
    return (
      <Redirect
        state={{ from: `/company/poa/${companyId}` }}
        to={paths.editCompanyWithKey(companyId)}
      />
    )
  }

  if (!userProfile?.name || !userProfile?.surname) {
    snackbar.warning(t('profile.poa.fillProfileDetailsMessage'))
    return (
      <Redirect
        state={{ from: `/company/poa/${companyId}` }}
        to={paths.myProfile}
      />
    )
  }

  return (
    <PageMainContent>
      <PageForm />
    </PageMainContent>
  )
}
